import { types } from '../actions/types';

export const ReportReducer = (
  state = {
    dashboard: null,
  },
  action,
) => {
  switch (action.type) {
    case types.rpGetDashboard:
      return {
        ...state,
        dashboard: {
          status: action.payload?.status,
          message: action.payload?.message,
          data: action.payload?.data,
        },
      };
    default:
      return state;
  }
};
